<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addBusinessRouterName" v-if="permissionCodes.indexOf('017003001') !== -1" />
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('017003002') !== -1" />
      </div>
      <input-search placeholder="招商人员" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除招商人员？'" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'investment-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧经纪',
          name: 'investment-manage'
        }, {
          value: '招商部管理'
        }],
        addBusinessRouterName: 'investment-add',
        operationArr: ['delete'],
        tableHead: [{
          prop: 'personName',
          label: '姓名'
        }, {
          prop: 'personPhone',
          label: '手机号'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.post(api.getPagePlatform, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取失败'))
      },
      search (v) {
        this.requestData.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      deleteSelection () {
        if (this.selectionArr.length === 0) {
          nAlert('请先选择需要删除的招商人员')
          return false
        } else {
          this.$confirm('是否确认删除招商人员？', '提示')
            .then(() => {
              this.deleteLine(this.selectionArr)
            })
            .catch(() => {
              console.log('取消删除')
            })
        }
      },
      deleteLine (code) {
        this.$axios.post(api.deletePlatform, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除招商人员失败'))
      }
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/investmentManage/investmentManage.vue